import { gql } from '@apollo/client';

const observationAssignmentsFragment = gql`
  fragment ObservationAssignmentsFields on EventObservationAssignment {
    ObserverExternalUserId
    ObservedExternalUserId
  }
`;

export default observationAssignmentsFragment;
